
define(
	'Dev.ShoppingActions.ShoppingActionsModule'
,   [
		'Dev.ShoppingActions.ShoppingActionsModule.Router',
		'Dev.ShoppingActions.ShoppingActionsModule.CutLinkOptionView',
		'ContactusHome.View',
		'underscore',
		'Utils'
	]
,   function (
		Router,
		ShoppingActionsModuleCutLikOptionView,
		ContactusHomeView,
		_,
		Utils
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var pdp=container.getComponent('PDP');
			var cart = container.getComponent('Cart');
			var layout=container.getComponent('Layout');
			if(layout){
				jQuery('head').append(
					"<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':"+
					"new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],"+
					"j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src="+
					"'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);"+
					"})(window,document,'script','dataLayer','GTM-5R3ZWNZS');</script>"
				);
				jQuery('body').append(
					'<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5R3ZWNZS"'+
					'height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>'
				);

			}
			if(layout)
			{
				layout.addChildView('Contactus.Home', function() { 
					return new ContactusHomeView({ container: container });
				});
			}
			
			if(pdp){
				pdp.addChildViews(
					'ProductDetails.Full.View'
				,	{
						'Quantity': {
							'Dev.ShoppingActions.ShoppingActionsModule.CutLinkOptionView':
							{
								childViewIndex: 10
							,	childViewConstructor: function()
								{
									return new ShoppingActionsModuleCutLikOptionView({
										pdp: pdp
									});
								}
							}
						}
					}
				);
				//$(".grid-order-cell-price-schedule ").removeClass("collapsed");
				//$('.grid-order-cell-price-schedule ul').removeClass("collapse");
			}
			if(cart)
			{
				cart.on('beforeAddLine', function preventMoreThanFive (line_item) {
                    //console.log(line_item);
                    //console.log(SC.is_show_cut_option);
                    if(SC.is_show_cut_option){
	                    var cut_link_option =_.find(line_item.line.options, function(option){
	                    	console.log(option)
	                    	if(option.cartOptionId == 'custcol_web_cut_link')
	                    		return option;
	                    });
	                    //console.log(cut_link_option);
	                   	if(cut_link_option && cut_link_option.value && cut_link_option.value.internalid != ''){
	                   		return new jQuery.Deferred().resolve();
	                   	}
	                   	else{
	                   		return new jQuery.Deferred().reject("Please Specify Header Track Length")
	                   	}
	                    // pdp.showMessage({
	                    //     message: 'Please Specify Header Track Length',
	                    //     type: 'error',
	                    //     selector: 'cutlink-error',
	                    //     timeout: 10000
	                    // });
	                    
	                }
	                else{
	                	return new jQuery.Deferred().resolve();
	                }
                });

                //shipping cost total calculating - Archi
				cart.addToViewContextDefinition('Cart.Summary.View', 'totalshipcost', 'string', function(context) {
					console.log("context",context);
					var ship_cost=Number(context.model.summary.shippingcost);
					var hadling_cost=Number(context.model.summary.handlingcost);
					var total_ship_cost=parseFloat(ship_cost+hadling_cost).toFixed(2);
					var ship_cost_formatted=Utils.formatCurrency(total_ship_cost);
						console.log("ship_cost_formatted",ship_cost_formatted);
					return ship_cost_formatted;
				});
			}
			return new Router(container);

		}
	};
});
